import React from 'react'
import {useRef} from "react";
import {FaBars, FaTimes} from "react-icons/fa";
import './header.css'


export default function Header() {

  const navRef = useRef();
  const showNavbar = () =>{
    navRef.current.classList.toggle("responsive_nav");
  }
  return (
    <header>
        <img 
            src="/images/logo.jpg" 
            alt="logo"
            className="header--logo"    
        /> 
        <nav ref={navRef}>
            <a href="/home">HOME</a>
            <a href="/about">ABOUT</a>
            <a href="/menu">MENU</a>
            <a href="/reservation">RESERVATIONS</a>
            <a href="*">ORDER ONLINE</a>
            <a href="/login">LOGIN</a>
            <button className="nav-btn nav-close-btn" onClick={showNavbar}>
                <FaTimes />
            </button>
        </nav>
        <button className="nav-btn" onClick={showNavbar}>
                <FaBars />
            </button>
    </header>
  )
}
